import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGE } from '@portal/config/env';
import ptBR from './pt-br.json';

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': {
      translation: ptBR,
    },
    pt: {
      translation: ptBR,
    },
  },
  lng: LANGUAGE,
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
